import { render, staticRenderFns } from "./AskDwgList.vue?vue&type=template&id=96f1dc9c&scoped=true&"
import script from "./AskDwgList.vue?vue&type=script&lang=js&"
export * from "./AskDwgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f1dc9c",
  null
  
)

export default component.exports